import Clarity from "@microsoft/clarity";

// Clarity only loads when the build has a project ID (test and prod CI builds).
// Local and dev builds leave REACT_APP_CLARITY_PROJECT_ID empty, so nothing is tracked.
let clarityEnabled = false;

export const initClarity = () => {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID?.trim();
  if (!projectId || clarityEnabled) {
    return;
  }

  try {
    Clarity.init(projectId);
    Clarity.setTag("environment", process.env.REACT_APP_ENV || "unknown");
    clarityEnabled = true;
  } catch (error) {
    console.error("Error initializing Clarity:", error);
  }
};

export const identifyClarityUser = () => {
  if (!clarityEnabled || !localStorage.getItem("token")) {
    return;
  }

  try {
    const organizationName = localStorage.getItem("organizationName");
    if (organizationName) {
      Clarity.setTag("organization", organizationName);
    }
    Clarity.setTag("superAdmin", localStorage.getItem("superAdmin") ?? "false");

    // Clarity hashes the custom ID client-side before sending it.
    const username = localStorage.getItem("username");
    if (username) {
      Clarity.identify(username);
    }
  } catch (error) {
    console.error("Error identifying Clarity user:", error);
  }
};
